import { z } from 'zod';
import { ProcessCategorySchema } from '../../entities/process/process.schema';
import { ObjectIdSchema } from '../../shared/object-id.schema';
/**
 * Bulk Add Process Input Schema
 * Post-onboarding bulk creation: owner is a userId (or falls back to the
 * department manager). The initial-setup wizard uses its own ownerEmail
 * shape (see initialize-add-processes). Accountable comes only from the
 * manual/edit dialogs — the Excel template deliberately has no such column.
 */ export const ProcessInputSchema = z.strictObject({
    name: z.string(),
    description: z.string(),
    department: z.string(),
    owner: z.string().optional(),
    accountable: ObjectIdSchema.or(z.literal('')).optional(),
    category: ProcessCategorySchema.nullable().optional()
});
export const BulkAddProcessesRequestSchema = z.object({
    processes: z.array(ProcessInputSchema)
});
export const BulkAddProcessesResponseSchema = z.void();

//# sourceMappingURL=bulk-add-processes.schema.js.map